import { render, staticRenderFns } from "./CreateCourse.vue?vue&type=template&id=608e8002"
import script from "../../services/teacher/create-course.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/create-course.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/create-course.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports